var $kDKNN$react = require("react");
var $kDKNN$reactvisibilitysensor = require("react-visibility-sensor");
var $kDKNN$reactjsxruntime = require("react/jsx-runtime");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "VisibilitySensor", {
    enumerable: true,
    get: function get() {
        return $4162ea33faa774c7$exports.VisibilitySensor;
    }
});
var $4162ea33faa774c7$exports = {};
"use strict";
function $4162ea33faa774c7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4162ea33faa774c7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4162ea33faa774c7$var$_typeof(o);
}
Object.defineProperty($4162ea33faa774c7$exports, "__esModule", {
    value: true
});
$4162ea33faa774c7$exports.VisibilitySensor = void 0;

var $4162ea33faa774c7$var$_react = $4162ea33faa774c7$var$_interopRequireWildcard($kDKNN$react);

var $4162ea33faa774c7$var$_reactVisibilitySensor = $4162ea33faa774c7$var$_interopRequireDefault($kDKNN$reactvisibilitysensor);
var $b50bf75d3e6387b9$exports = {};
"use strict";
Object.defineProperty($b50bf75d3e6387b9$exports, "__esModule", {
    value: true
});
$b50bf75d3e6387b9$exports.handleVisibleOnChange = void 0;
var $b50bf75d3e6387b9$var$handleVisibleOnChange = $b50bf75d3e6387b9$exports.handleVisibleOnChange = function handleVisibleOnChange(once, setActive) {
    return function(isVisible) {
        return once && isVisible && setActive(false);
    };
};



var $4162ea33faa774c7$var$_excluded = [
    "once",
    "children"
];
function $4162ea33faa774c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4162ea33faa774c7$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4162ea33faa774c7$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $4162ea33faa774c7$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $4162ea33faa774c7$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $4162ea33faa774c7$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $4162ea33faa774c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4162ea33faa774c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4162ea33faa774c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4162ea33faa774c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4162ea33faa774c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4162ea33faa774c7$var$_defineProperty(e, r, t) {
    return (r = $4162ea33faa774c7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4162ea33faa774c7$var$_toPropertyKey(t) {
    var i = $4162ea33faa774c7$var$_toPrimitive(t, "string");
    return "symbol" == $4162ea33faa774c7$var$_typeof(i) ? i : i + "";
}
function $4162ea33faa774c7$var$_toPrimitive(t, r) {
    if ("object" != $4162ea33faa774c7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4162ea33faa774c7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4162ea33faa774c7$var$_slicedToArray(r, e) {
    return $4162ea33faa774c7$var$_arrayWithHoles(r) || $4162ea33faa774c7$var$_iterableToArrayLimit(r, e) || $4162ea33faa774c7$var$_unsupportedIterableToArray(r, e) || $4162ea33faa774c7$var$_nonIterableRest();
}
function $4162ea33faa774c7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4162ea33faa774c7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4162ea33faa774c7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4162ea33faa774c7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4162ea33faa774c7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $4162ea33faa774c7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4162ea33faa774c7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $4162ea33faa774c7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4162ea33faa774c7$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $4162ea33faa774c7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4162ea33faa774c7$var$VisibilitySensor = $4162ea33faa774c7$exports.VisibilitySensor = function VisibilitySensor(_ref) {
    var _ref$once = _ref.once, once = _ref$once === void 0 ? false : _ref$once, _children = _ref.children, theRest = $4162ea33faa774c7$var$_objectWithoutProperties(_ref, $4162ea33faa774c7$var$_excluded);
    var _useState = (0, $4162ea33faa774c7$var$_react.useState)(true), _useState2 = $4162ea33faa774c7$var$_slicedToArray(_useState, 2), active = _useState2[0], setActive = _useState2[1];
    return /*#__PURE__*/ (0, $kDKNN$reactjsxruntime.jsx)($4162ea33faa774c7$var$_reactVisibilitySensor["default"], $4162ea33faa774c7$var$_objectSpread($4162ea33faa774c7$var$_objectSpread({
        active: active,
        onChange: (0, $b50bf75d3e6387b9$exports.handleVisibleOnChange)(once, setActive)
    }, theRest), {}, {
        children: function children(_ref2) {
            var isVisible = _ref2.isVisible;
            return _children({
                isVisible: isVisible
            });
        }
    }));
};




//# sourceMappingURL=index.js.map
